<template>
  <div>
    <div class="home">
      <div class="content">
        <img class="mobile_logo" src="/mobile/static/img/restricted_prompt/mobile_logo.png" alt="">
        <div class="mobile_content">
          <p class="title primary_color"><img class="mark_icon" src="/mobile/static/img/restricted_prompt/mark_icon.png" alt=""> Website Access Geo-Restricted</p>
          <p>Please note that you are attempting to access our website from a geographical location which is <a style="box-shadow: 0 1px;" place="link" target="_blank" href="/mobile/restricted_territory">restricted</a> and/or from an IP address which we block.  Pursuant to the Online Gambling Regulation Act 2001 and the licensing conditions laid down by Isle of Man Gambling Supervision Commission, we are unable to provide any service in your current territory.</P>
          <p>If you believe that is incorrect, please contact us at <a place="link" href="mailto:info@kkpoker.net">info@kkpoker.net</a>. </p>
          <p style="font-weight:400;">Online gaming may not be legal for residents of, or persons located in, certain countries. If you have any concerns about the legality of your participation in online gaming, you should seek independent legal advice.</p>
        </div>
      </div>
      <prompt-footer></prompt-footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import promptFooter from '@/components/layout/PromptFooter'
import { getGps } from '@/utils/browserCheck'

async function toJudgeIp () {
  var $XHR = new XMLHttpRequest()
  $XHR.onreadystatechange = function () {
    if ($XHR.readyState === 4) { // 请求成功
      if ($XHR.status === 200) { // 响应成功
        var $RESPONSE = JSON.parse($XHR.response)
        console.log($RESPONSE)
        if ($RESPONSE.legal === 1 || $RESPONSE.legal === 3) {
          // window.location.href = 'https://www.kkpoker.net'
          window.location.replace('https://www.kkpoker.net')
        }
      }
    }
  }

  // 判斷是否為手機及獲取經緯度
  const { lat, lon } = await getGps()
  const apiUrl = 'https://api.kklogin.net/poker-api'
  const baseUrl = `${apiUrl}/checkIpLegal?from=1&time=${new Date().getTime()}`
  const url = lat && lon ? `${baseUrl}&gps_lat=${lat}&gps_lon=${lon}` : baseUrl
  $XHR.open('get', url, true)
  // $XHR.open('get', 'http://47.91.130.120:10012/poker-api/checkIpLegal?from=1&time=' + new Date().getTime(), true)

  $XHR.send(null)
}
export default {
  data () {
    return {
    }
  },
  created () {
    toJudgeIp()
  },
  components: {
    promptFooter
  },
  methods: {
    isMobileDevice () {
      const ua = navigator.userAgent.toLowerCase()
      const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mac|/i.test(ua)
      return !!(isMobile && navigator.maxTouchPoints > 1)
    },
    getPosition () {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
    },
    async getGps () {
      let lat = 0 // latitude
      let lon = 0 // longitude
      const position = await this.getPosition().catch(() => {})
      if (this.isMobileDevice() && position) {
        lat = (position.coords.latitude * 1000000).toFixed(0) || 0
        lon = (position.coords.longitude * 1000000).toFixed(0) || 0
      }
      return { lat, lon }
    }
  }
}
</script>

<style lang="scss" scoped>
  .home {
    position: relative;

    background-image: url("/mobile/static/img/restricted_prompt/mobile_bg.jpg");
    background-repeat: no-repeat;
    // background-size: cover;
    background-position: top center;
    background-size: 100% auto;
    background-color: #050505;

    width: 100%;
    // height: 100%;
    height: 1500px;
    font-size: 24px;
    color: #e7e7e7;
    .content {
      padding: 140px 60px 40px 60px;
      text-align: center;
      .mobile_logo {
        display: inline-block;
        width: 420px;
        text-align: center;
        margin-bottom: 80px;
      }
      .mobile_content {
        width: 100%;
        text-align: left;
        .title {
          font-weight: bold;
          font-size: 36px;
          line-height: 40px;
          vertical-align: middle;
          color: #219655;
          margin-bottom: 30px;
          .mark_icon {
            vertical-align: middle;
            height: 36px;
            display: inline-block;
            margin-bottom: 6px;
          }
        }
        p {
          font-size: 26px;
          line-height: 36px;
          margin-bottom: 20px;
          font-weight: 100;
          padding-left: 16px;
          a {
            font-weight: 400;
            color: #e7e7e7;
            font-size: 26px;
          }
        }
      }
    }
  }
</style>
